module.exports = {
          srcSet: __webpack_public_path__ + "public/images/e590988ad29aa05d92aa843e29e4604c-1774.webp"+" 1774w",
          images:[ {path: __webpack_public_path__ + "public/images/e590988ad29aa05d92aa843e29e4604c-1774.webp",width: 1774,height: 887}],
          src: __webpack_public_path__ + "public/images/e590988ad29aa05d92aa843e29e4604c-1774.webp",
          toString:function(){return __webpack_public_path__ + "public/images/e590988ad29aa05d92aa843e29e4604c-1774.webp"},
          
          width: 1774,
          height: 887
        }